var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "url(#paint0_linear_5394_1625)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "url(#paint1_linear_5394_1625)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "url(#paint2_linear_5394_1625)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "url(#paint3_linear_5394_1625)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5394_1625)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5394_1625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 29H29.373C29.2233 28.2708 28.9596 27.6003 28.582 26.9883C28.2044 26.3763 27.7454 25.849 27.2051 25.4062C26.6647 24.9635 26.056 24.6185 25.3789 24.3711C24.7018 24.1237 23.9922 24 23.25 24C22.6771 24 22.1237 24.0749 21.5898 24.2246C21.056 24.3743 20.5579 24.5827 20.0957 24.8496C19.6335 25.1165 19.2135 25.4421 18.8359 25.8262C18.4583 26.2103 18.1328 26.6335 17.8594 27.0957C17.5859 27.5579 17.3743 28.056 17.2246 28.5898C17.0749 29.1237 17 29.6771 17 30.25H15.75C15.75 29.4688 15.8639 28.7168 16.0918 27.9941C16.3197 27.2715 16.6484 26.6042 17.0781 25.9922C17.5078 25.3802 18.0156 24.8366 18.6016 24.3613C19.1875 23.8861 19.8516 23.5117 20.5938 23.2383C19.8581 22.7565 19.2852 22.151 18.875 21.4219C18.4648 20.6927 18.2565 19.8854 18.25 19C18.25 18.3099 18.3802 17.6621 18.6406 17.0566C18.901 16.4512 19.2559 15.9206 19.7051 15.4648C20.1543 15.0091 20.6849 14.651 21.2969 14.3906C21.9089 14.1302 22.5599 14 23.25 14C23.9401 14 24.5879 14.1302 25.1934 14.3906C25.7988 14.651 26.3294 15.0059 26.7852 15.4551C27.2409 15.9043 27.599 16.4349 27.8594 17.0469C28.1198 17.6589 28.25 18.3099 28.25 19C28.25 19.4297 28.1979 19.8496 28.0938 20.2598C27.9896 20.6699 27.8333 21.0573 27.625 21.4219C27.4167 21.7865 27.1725 22.1217 26.8926 22.4277C26.6126 22.7337 26.2839 23.0039 25.9062 23.2383C26.6354 23.5182 27.306 23.9023 27.918 24.3906C28.5299 24.8789 29.0573 25.4518 29.5 26.1094V29ZM19.5 19C19.5 19.5208 19.5977 20.0059 19.793 20.4551C19.9883 20.9043 20.2552 21.3014 20.5938 21.6465C20.9323 21.9915 21.3294 22.2617 21.7852 22.457C22.2409 22.6523 22.7292 22.75 23.25 22.75C23.7643 22.75 24.2493 22.6523 24.7051 22.457C25.1608 22.2617 25.5579 21.9948 25.8965 21.6562C26.235 21.3177 26.5052 20.9206 26.707 20.4648C26.9089 20.0091 27.0065 19.5208 27 19C27 18.4857 26.9023 18.0007 26.707 17.5449C26.5117 17.0892 26.2448 16.6921 25.9062 16.3535C25.5677 16.015 25.1673 15.7448 24.7051 15.543C24.2428 15.3411 23.7578 15.2435 23.25 15.25C22.7292 15.25 22.2441 15.3477 21.7949 15.543C21.3457 15.7383 20.9486 16.0052 20.6035 16.3438C20.2585 16.6823 19.9883 17.0827 19.793 17.5449C19.5977 18.0072 19.5 18.4922 19.5 19ZM32 30.25H34.5V31.5H32V34H30.75V31.5H28.25V30.25H30.75V27.75H32V30.25Z",
    fill: "#A685FA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5394_1625",
    x1: 4.45122,
    y1: 50.6341,
    x2: 50.6951,
    y2: -3.21951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A685FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#A685FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5394_1625",
    x1: 48.3537,
    y1: -6.14634,
    x2: 4.45122,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A685FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#A685FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5394_1625",
    x1: 2.58064,
    y1: 8.03226,
    x2: 42.3548,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A685FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#A685FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5394_1625",
    x1: 49.6129,
    y1: 50.129,
    x2: 7.80645,
    y2: 20.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A685FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#A685FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5394_1625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14.5 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5394_1625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14.5 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add_user.9f075b9d2036eb2e40e660fa5734c1c1.svg";
export { ForwardRef as ReactComponent };